module.exports = __webpack_public_path__ + "static/media/028.5c696a31.jpg";